import React from 'react';
import {observer} from 'mobx-react';
import Draggable from 'react-draggable';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {
    PartyJackpotInGameWidgetAmountContainerBox,
    PartyJackpotInGameWidgetClockContainerBox,
    PartyJackpotInGameWidgetContainerBox,
    PartyJackpotInGameWidgetContentContainerBox
} from './boxes';
import {JackpotWidgetClockComponent} from '../jackpot-widget/jackpot-widget-clock.component';
import {CyClass} from '../../../common/cy-classes';
import {IPartyJackpotInGameWidgetComponentProps} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/party-jackpot-ingame-widget.component-props';
import { PartyJackpotJoinStatus } from '../../../common/interfaces/blue-ribbon-party-jackpot.interface';

@observer
export class PartyJackpotInGameWidgetComponent extends OrbitComponent<IPartyJackpotInGameWidgetComponentProps> {

    private isDragging: boolean = false;

    private _getCurrentJackpotAmount() {
        const amountInCents = this.props.partyJackpot.currentValue;
        return <PartyJackpotInGameWidgetAmountContainerBox
            className={CyClass('cy-party-jackpot-in-game-widget-amount')}>
            {this.services.currency.formatMoney(amountInCents)}
        </PartyJackpotInGameWidgetAmountContainerBox>;
    }

    private _getClock() {
        if (this.props.partyJackpot.mustHitTime) {
            const mustHitTimeFn = () => {
                return this.props.partyJackpot.mustHitTime;
            };
            
            return (
                <PartyJackpotInGameWidgetClockContainerBox>
                    <JackpotWidgetClockComponent getMustHitTime={mustHitTimeFn}
                                                 jackpotState={this.props.partyJackpot.getStandardJackpotState()}
                                                 forcePCView={true}
                    />
                </PartyJackpotInGameWidgetClockContainerBox>
            );
        }

        return null;
    }

    private _onClick() {
        this.props.onClick && this.props.onClick();
    }

    private _onDrag = () => {
        this.isDragging = true;
    }

    private _onStop = () => {
        if (!this.isDragging) {
            this._onClick();
        }

        this.isDragging = false;
    }

    private _isRTL() {
        return this.services.language.isRTLLanguage;
    }

    private _isMobile() {
        return this.services.device.isMobile;
    }

    private _getInitialXAxisPosition() {
        /**
         * Calculate the X position, Because a bad calculation of the `Draggable` library,
         * in RTL we put 210 for desktop or 105 for mobile, on LTR, we can leave it zero.
         * This caused because the width of the widget which can also be found in the container box
         * Related bug: Bug 1661619
         */
        
        // on mobile, offset X position with half of the width
        return (this._isRTL() ? this._getWidth() : 0) + this.props.initialX ?? 0;
    }

    private _getInitialYAxisPosition() {
        return this.props.initialY ?? 0;
    }

    private _getWidth() {
        return this._isMobile() ? 105 : 210;
    }
    render() {
        if (!this.props.partyJackpot.isActive || this.props.partyJackpot.joinStatus === PartyJackpotJoinStatus.NotJoined) {
            return null;
        }

        if (!this.props.partyJackpot.isOptedIn) {
            return null;
        }
        
        return (
            <Draggable onDrag={this._onDrag} onStop={this._onStop} bounds={this.props.boundSelector || null} defaultPosition={{x: this._getInitialXAxisPosition(), y: this._getInitialYAxisPosition()}}>
                <PartyJackpotInGameWidgetContainerBox className={CyClass('cy-party-jackpot-in-game-container')}>
                    <PartyJackpotInGameWidgetContentContainerBox>
                        {this._getCurrentJackpotAmount()}
                        {this._getClock()}
                    </PartyJackpotInGameWidgetContentContainerBox>
                </PartyJackpotInGameWidgetContainerBox>
            </Draggable>
        )
    }
}
